import { render } from "./Calm.vue?vue&type=template&id=4bf881dc"
import script from "./Calm.vue?vue&type=script&lang=js"
export * from "./Calm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__